import type { NavigateFunction } from 'react-router-dom';

let navigateRef: NavigateFunction | null = null;

export function setNavigate(fn: NavigateFunction): void {
  navigateRef = fn;
}

/** Navega fora de componentes (ex: interceptor axios). No-op se o router ainda não montou. */
export function navigate(path: string): void {
  if (navigateRef) navigateRef(path);
  else window.location.assign(path);
}
